/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakewaiting1Inputs */

const en_intakewaiting1 = /** @type {(inputs: Intakewaiting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for AI…`)
};

const pt_intakewaiting1 = /** @type {(inputs: Intakewaiting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À espera da IA…`)
};

/**
* | output |
* | --- |
* | "Waiting for AI…" |
*
* @param {Intakewaiting1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakewaiting1 = /** @type {((inputs?: Intakewaiting1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakewaiting1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakewaiting1(inputs)
	return pt_intakewaiting1(inputs)
});
export { intakewaiting1 as "intakeWaiting" }